import { useEffect, useRef } from 'react'

/**
 * 产生一个可用于延时处理的定时器，初始为空
 * 这个定时器只保留一个，即原来的定时器如果还没执行则会被清除。
 * 加入新处理函数时如果cdt不为true，则不会执行
 * 引用该hook的组件卸载时会清除该hook中的定时器
 */
export const useDelayTimer = (delayTime = 1000) => {
	const { current: me, current: { stopDelay, doDelay, newDelay } } = useRef({
		tmr: undefined as any,
		stopDelay: () => { me.tmr && (clearTimeout(me.tmr), me.tmr = null) },
		doDelay: (fn: Function, cdt = true, t = delayTime) => { (stopDelay(), cdt && (me.tmr = setTimeout(() => (me.tmr = null, fn()), t))) },
		newDelay: (fn: Function, t = delayTime, cdt = true) => { (stopDelay(), cdt && (me.tmr = setTimeout(() => (me.tmr = null, fn()), t))) }
	})

	useEffect(() => () => stopDelay(), [])

	return { stopDelay, doDelay, newDelay }
}